import { render, staticRenderFns } from "./TodoList.vue?vue&type=template&id=6b13bd52&scoped=true"
import script from "./TodoList.vue?vue&type=script&lang=js"
export * from "./TodoList.vue?vue&type=script&lang=js"
import style0 from "./TodoList.vue?vue&type=style&index=0&id=6b13bd52&prod&lang=less&scoped=true"
import style1 from "./TodoList.vue?vue&type=style&index=1&id=6b13bd52&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b13bd52",
  null
  
)

export default component.exports